import {useMemo, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {FmlxButton, FmlxComboBox} from "fmlx-common-ui";
import {assignEvent, confirmSaveEvent} from "../../../stores/business/teamAssignmentBusiness";
import { availableEmployeeSelector, sortedDepartmentsSelector, teamAssignmentSelector} from "../../../stores/selectors/teamAssignmentSelector";

import "../TeamAssignment.scss";

function AddMemberControls() {
  const dispatch = useDispatch();
  const {
    saveAssignButton,
    departments,
    availableEmployee
  } = useSelector((state) => ({
    saveAssignButton: teamAssignmentSelector(state).saveAssignButton,
    departments: sortedDepartmentsSelector(state),
    availableEmployee: availableEmployeeSelector(state),
  }));

  const [searchTerm, setSearchTerm] = useState("");


  const handleSearcInputhChange = (evt) => {
    setSearchTerm(evt.target.value);
  };

  const memoizedFilteredEmployee = useMemo(() => {
    const q = searchTerm.trim().toLowerCase();

    const filteredEmployee = availableEmployee.filter(({ employee }) =>
      employee.fullName.toLowerCase().includes(q)
    );

    const employeeItems = filteredEmployee.map(emp => ({
      id: emp.id,
      key: `${emp.practice.department.longName} - ${emp.id}`,
      text: emp.fullName,
      group:
        departments.find(d => d.id === emp.practice.department.id)
          ?.departmentName
        || emp.practice.department.longName,
      data: emp,
    }));

    return employeeItems;

  }, [availableEmployee, searchTerm, departments]);

  return (
    <>
      <div className="add-member-controls-container">
        <div className="section-left">
          <p>Add Member</p>
          <FmlxComboBox
            id="employee-search"
            placeholder="Add Member"
            size="md"
            variant="combobox"
            items={memoizedFilteredEmployee}
            selectedItem={null}
            showClearChip={true}
            showClearInput={true}
            onChange={(selectedEmployee) => {
              if (selectedEmployee) {
                dispatch(assignEvent(selectedEmployee.data));
              }
            }}
            onSearchChange={handleSearcInputhChange}
            value={searchTerm}
          />
        </div>
        <div className="section-right">
          <FmlxButton
            label="Save"
            disabled={!saveAssignButton}
            type={FmlxButton.Type.PRIMARY}
            variant={FmlxButton.Variant.CONTAIN}
            onClick={() => dispatch(confirmSaveEvent())}
            size={FmlxButton.Size.MEDIUM}
          />
        </div>
      </div>
    </>
  );
}

export default AddMemberControls;